import * as locationsService from '../services/locationsService';
import * as locationsActionsConstants from '../constants/actions/locationsActions';

export function getCountries() {
    return dispatch => {
        return locationsService.getCountries().then(response => {
            dispatch({type: locationsActionsConstants.GET_COUNTRIES_SUCCESS, payload: response.data.payload});
        });
    };
}